var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  return _vm.edit()
                }
              }
            },
            [_vm._v("Edit Corporation")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.corporation
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.corporationId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.name))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", { staticClass: "align-content-center" }, [
                  _vm._v("image")
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("img", {
                    staticClass: "detail-thumbnail",
                    attrs: {
                      src: _vm.corporation.smallImage,
                      alt: "corporation-image"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.description))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("account limit")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.accountLimit))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("domain")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.domain))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("contact address")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.contactAddress))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("contact city")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.contactCity))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("contact email")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.contactEmail))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("contact first name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.contactFirstName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("contact last name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.contactLastName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("contact phone")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.contactPhone))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("contact state")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.contactState))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("contact zip")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.contactZip))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("welcome message")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.welcomeMessage))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Gift Redeem Package Description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.signupGiftDesc))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v("Stop sending Freemium, Teaser and Takeaway emails")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.corporation.filterEmails === 1 ? "Yes" : "No")
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Enable Community Page")]),
                _vm._v(" "),
                _c("td", [
                  _vm.corporation.enableCorporatePage
                    ? _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v("Yes")
                      ])
                    : _c("span", { staticClass: "badge badge-danger" }, [
                        _vm._v("No")
                      ])
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Enable Spotlight Section")]),
                _vm._v(" "),
                _c("td", [
                  _vm.corporation.showSpotlightSection
                    ? _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v("Yes")
                      ])
                    : _c("span", { staticClass: "badge badge-danger" }, [
                        _vm._v("No")
                      ])
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Enable Pinned Messages Section")]),
                _vm._v(" "),
                _c("td", [
                  _vm.corporation.showPinnedMessages
                    ? _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v("Yes")
                      ])
                    : _c("span", { staticClass: "badge badge-danger" }, [
                        _vm._v("No")
                      ])
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Corporate Page Welcome Message")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.pageWelcomeMessage))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Page Administrator")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.corporation.pageAdmin
                        ? _vm.corporation.pageAdmin
                        : "N/A"
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Community Page Default Tab")]),
                _vm._v(" "),
                _vm.corporation.defaultCorpTab === 1
                  ? _c("td", [_vm._v("Career Coaching")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.defaultCorpTab === 2
                  ? _c("td", [_vm._v("Community")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.defaultCorpTab === 3
                  ? _c("td", [_vm._v("Playlists")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.defaultCorpTab === 4
                  ? _c("td", [_vm._v("Videos")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", { staticClass: "align-content-center" }, [
                  _vm._v("Spotlight Picture")
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("img", {
                    staticClass: "detail-thumbnail",
                    attrs: {
                      src: _vm.corporation.spotlightPic,
                      alt: "corporation-image"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Spotlight Quote")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.spotlightQuote))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Spotlight Para1")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.spotlightPara1))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Spotlight Para2")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.spotlightPara2))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Spotlight Para3")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.spotlightPara3))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Private Event Section Heading")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.privateEventHeading))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("TONE Event Section Heading")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.toneEventHeading))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Archived Events Section Heading")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.archiveEventHeading))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Playlist Section Heading")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.playlistHeading))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Pinned Messages Section Heading")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.pinnedMessageHeading))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Show Shoe Motif")]),
                _vm._v(" "),
                _vm.corporation.showShoeMotif === 1
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.showShoeMotif !== 1
                  ? _c("td", [_vm._v("Hidden")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Private Videos Section Heading")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.videoTabHeading))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Mobile Field Visibility")]),
                _vm._v(" "),
                _vm.corporation.phoneFlag === 1
                  ? _c("td", [_vm._v("Show on Profile & Signup")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.phoneFlag === 2
                  ? _c("td", [_vm._v("Show on Profile")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.phoneFlag === 3
                  ? _c("td", [_vm._v("Show on Signup")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.phoneFlag === 4
                  ? _c("td", [_vm._v("Hide on Profile & Signup")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("DOB Field Visibility")]),
                _vm._v(" "),
                _vm.corporation.dobFlag === 1
                  ? _c("td", [_vm._v("Show on Profile")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.dobFlag === 2
                  ? _c("td", [_vm._v("Hide on Profile")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Videos (To Show)")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.csvShowVideoCodes))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Videos (To Hide)")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.csvHiddenVideoCodes))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v("Suggested Videos for New Users (Profile/Progress)")
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.profileCsvVideos))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Custom Banner Settings")]),
                _vm._v(" "),
                _vm.corporation.giftIconState === 1
                  ? _c("td", [_vm._v("Gift of TONE Visible")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.giftIconState === 2
                  ? _c("td", [
                      _vm._v("Gift of TONE Invisible Without Custom Message'")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.giftIconState === 3
                  ? _c("td", [
                      _vm._v("Gift of TONE Invisible With Custom Message")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Custom Banner Message")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.giftIconMessage))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Custom Banner URL")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.giftIconUrl))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Event Banner Settings")]),
                _vm._v(" "),
                _vm.corporation.bnrLinkState === 1
                  ? _c("td", [_vm._v("Link to Public Event")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.bnrLinkState === 2
                  ? _c("td", [_vm._v("Link to Private Event")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.bnrLinkState === 3
                  ? _c("td", [_vm._v("Custom Link")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Event Banner (Start Date/Time)")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.bnrPvtStartTimeFmt))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Event Banner (End Date/Time)")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.bnrPvtEndTimeFmt))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Custom Event Banner Message")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.bnrCustomMsg))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Custom Event Banner URL")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.corporation.bnrCustomMsgUrl))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Send Email on Enabling Community Page")]),
                _vm._v(" "),
                _vm.corporation.cceSendEmail === 1
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.cceSendEmail === 0
                  ? _c("td", [_vm._v("No")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.cceSendEmail === 2
                  ? _c("td", [_vm._v("Yes (One time Email Sent)")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Allow Live Event Section")]),
                _vm._v(" "),
                _vm.corporation.cceLiveEventParaAccess === 1
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.cceLiveEventParaAccess === 0
                  ? _c("td", [_vm._v("No")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Allow Custom Content Section")]),
                _vm._v(" "),
                _vm.corporation.cceCustomContentAccess === 1
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.cceCustomContentAccess === 0
                  ? _c("td", [_vm._v("No")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Allow Coaching Section")]),
                _vm._v(" "),
                _vm.corporation.cceCommCoachingAccess === 1
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.cceCommCoachingAccess === 0
                  ? _c("td", [_vm._v("No")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Allow Video Share Section")]),
                _vm._v(" "),
                _vm.corporation.cceShareVideoAccess === 1
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.cceShareVideoAccess === 0
                  ? _c("td", [_vm._v("No")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Override Package Settings")]),
                _vm._v(" "),
                _vm.corporation.useTrialEndDateCustom === 1
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.useTrialEndDateCustom === 0
                  ? _c("td", [_vm._v("No")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.useTrialEndDateCustom === 1
                ? _c("tr", [
                    _c("th", [_vm._v("Trial Expiry Date")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm.corporation.trialEndDateCustom))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Video Share Permission (Corp)")]),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions.shareVideoPermission ===
                1
                  ? _c("td", [_vm._v("Allow All Users Full Access")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions.shareVideoPermission ===
                4
                  ? _c("td", [_vm._v("Allow Full Access to Selected Users")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions.shareVideoPermission ===
                2
                  ? _c("td", [
                      _vm._v("All User share with Community with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions.shareVideoPermission ===
                3
                  ? _c("td", [
                      _vm._v(
                        "All User share with Individual with List of Users"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions.shareVideoPermission ===
                5
                  ? _c("td", [
                      _vm._v("All User share with Friends with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions.shareVideoPermission ===
                0
                  ? _c("td", [_vm._v("Do Not Allow Share")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.corpSharingPermissions.shareVideoPermission > 1
                ? _c("tr", [
                    _c("th", [_vm._v("Video Share Permission (User List)")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.corporation.corpSharingPermissions
                            .shrVidPermUserIdCsv
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v("Corporate Playlist Share Permission (Playlist Page)")
                ]),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .corpPlaylistShareOptnPermission === 1
                  ? _c("td", [_vm._v("Allow All Users Full Access")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .corpPlaylistShareOptnPermission === 4
                  ? _c("td", [_vm._v("Allow Full Access to Selected Users")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .corpPlaylistShareOptnPermission === 2
                  ? _c("td", [
                      _vm._v("All User share with Community with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .corpPlaylistShareOptnPermission === 3
                  ? _c("td", [
                      _vm._v(
                        "All User share with Individual with List of Users"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .corpPlaylistShareOptnPermission === 5
                  ? _c("td", [
                      _vm._v("All User share with Friends with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .corpPlaylistShareOptnPermission === 0
                  ? _c("td", [_vm._v("Do Not Allow Share")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.corpSharingPermissions
                .corpPlaylistShareOptnPermission > 1
                ? _c("tr", [
                    _c("th", [
                      _vm._v(
                        "Corporate Playlist Share Permission (Playlist - User List)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.corporation.corpSharingPermissions
                            .corpPlaylistShrareOptnCsv
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Corporate Playlist Share Permission")]),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareCompanyPlaylistPermission === 1
                  ? _c("td", [_vm._v("Allow All Users Full Access")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareCompanyPlaylistPermission === 4
                  ? _c("td", [_vm._v("Allow Full Access to Selected Users")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareCompanyPlaylistPermission === 2
                  ? _c("td", [
                      _vm._v("All User share with Community with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareCompanyPlaylistPermission === 3
                  ? _c("td", [
                      _vm._v(
                        "All User share with Individual with List of Users"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareCompanyPlaylistPermission === 5
                  ? _c("td", [
                      _vm._v("All User share with Friends with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareCompanyPlaylistPermission === 0
                  ? _c("td", [_vm._v("Do Not Allow Share")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.corpSharingPermissions
                .shareCompanyPlaylistPermission > 1
                ? _c("tr", [
                    _c("th", [
                      _vm._v("Corporate Playlist Share Permission (User List)")
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.corporation.corpSharingPermissions
                            .shrCompPlistPermUserIdCsv
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Personal Playlist Share Permission")]),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .sharePersonalPlaylistPermission === 1
                  ? _c("td", [_vm._v("Allow All Users Full Access")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .sharePersonalPlaylistPermission === 4
                  ? _c("td", [_vm._v("Allow Full Access to Selected Users")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .sharePersonalPlaylistPermission === 2
                  ? _c("td", [
                      _vm._v("All User share with Community with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .sharePersonalPlaylistPermission === 3
                  ? _c("td", [
                      _vm._v(
                        "All User share with Individual with List of Users"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .sharePersonalPlaylistPermission === 5
                  ? _c("td", [
                      _vm._v("All User share with Friends with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .sharePersonalPlaylistPermission === 0
                  ? _c("td", [_vm._v("Do Not Allow Share")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.corpSharingPermissions
                .sharePersonalPlaylistPermission > 1
                ? _c("tr", [
                    _c("th", [
                      _vm._v("Personal Playlist Share Permission (User List)")
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.corporation.corpSharingPermissions
                            .shrPerPlistPermUserIdCsv
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Trending Playlist Share Permission")]),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareTrendingPlaylistPermission === 1
                  ? _c("td", [_vm._v("Allow All Users Full Access")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareTrendingPlaylistPermission === 4
                  ? _c("td", [_vm._v("Allow Full Access to Selected Users")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareTrendingPlaylistPermission === 2
                  ? _c("td", [
                      _vm._v("All User share with Community with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareTrendingPlaylistPermission === 3
                  ? _c("td", [
                      _vm._v(
                        "All User share with Individual with List of Users"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareTrendingPlaylistPermission === 5
                  ? _c("td", [
                      _vm._v("All User share with Friends with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareTrendingPlaylistPermission === 0
                  ? _c("td", [_vm._v("Do Not Allow Share")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.corpSharingPermissions
                .shareTrendingPlaylistPermission > 1
                ? _c("tr", [
                    _c("th", [
                      _vm._v("Trending Playlist Share Permission (User List)")
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.corporation.corpSharingPermissions
                            .shrTrndPlistPermUserIdCsv
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v("Archive Playlist Share Permissions(Events Page)")
                ]),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareEventCoachingTipPermission === 1
                  ? _c("td", [_vm._v("Allow All Users Full Access")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareEventCoachingTipPermission === 4
                  ? _c("td", [_vm._v("Allow Full Access to Selected Users")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareEventCoachingTipPermission === 2
                  ? _c("td", [
                      _vm._v("All User share with Community with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareEventCoachingTipPermission === 3
                  ? _c("td", [
                      _vm._v(
                        "All User share with Individual with List of Users"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareEventCoachingTipPermission === 5
                  ? _c("td", [
                      _vm._v("All User share with Friends with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareEventCoachingTipPermission === 0
                  ? _c("td", [_vm._v("Do Not Allow Share")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.corpSharingPermissions
                .shareEventCoachingTipPermission > 1
                ? _c("tr", [
                    _c("th", [
                      _vm._v(
                        "Archive Playlist Share Permissions on Events Page (User List)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.corporation.corpSharingPermissions
                            .shrEventCoachPlistPermUserIdCsv
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v("Archive Playlist Share Permissions(Experts Page)")
                ]),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareExpertCoachingTipPermission === 1
                  ? _c("td", [_vm._v("Allow All Users Full Access")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareExpertCoachingTipPermission === 4
                  ? _c("td", [_vm._v("Allow Full Access to Selected Users")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareExpertCoachingTipPermission === 2
                  ? _c("td", [
                      _vm._v("All User share with Community with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareExpertCoachingTipPermission === 3
                  ? _c("td", [
                      _vm._v(
                        "All User share with Individual with List of Users"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareExpertCoachingTipPermission === 5
                  ? _c("td", [
                      _vm._v("All User share with Friends with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareExpertCoachingTipPermission === 0
                  ? _c("td", [_vm._v("Do Not Allow Share")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.corpSharingPermissions
                .shareExpertCoachingTipPermission > 1
                ? _c("tr", [
                    _c("th", [
                      _vm._v(
                        "Archive Playlist Share Permissions on Experts Page (User List)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.corporation.corpSharingPermissions
                            .shrExpertCoachPlistPermUserIdCsv
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v(
                    "Archive Playlist Share Permissions(Archive Playlist Page)"
                  )
                ]),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareArchivePlistPermission === 1
                  ? _c("td", [_vm._v("Allow All Users Full Access")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareArchivePlistPermission === 4
                  ? _c("td", [_vm._v("Allow Full Access to Selected Users")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareArchivePlistPermission === 2
                  ? _c("td", [
                      _vm._v("All User share with Community with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareArchivePlistPermission === 3
                  ? _c("td", [
                      _vm._v(
                        "All User share with Individual with List of Users"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareArchivePlistPermission === 5
                  ? _c("td", [
                      _vm._v("All User share with Friends with List of Users")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.corporation.corpSharingPermissions
                  .shareArchivePlistPermission === 0
                  ? _c("td", [_vm._v("Do Not Allow Share")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.corporation.corpSharingPermissions
                .shareArchivePlistPermission > 1
                ? _c("tr", [
                    _c("th", [
                      _vm._v(
                        "Archive Playlist Share Permissions on Archive Playlist Page (User List)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.corporation.corpSharingPermissions
                            .shrArchivePlistPermUserIdCsv
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("status")]),
                _vm._v(" "),
                _c("td", [
                  _vm.corporation.active
                    ? _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v(" Active ")
                      ])
                    : _c("span", { staticClass: "badge badge-danger" }, [
                        _vm._v(" Inactive ")
                      ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-483f1242", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-483f1242","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Corporations/CorporationDetails.vue
// module id = xptc
// module chunks = 0